import { useMutation, useQueryClient } from '@tanstack/react-query'

import { api } from '@/lib/api-client'
import { MutationConfig } from '@/lib/react-query'

export type SubscriptionCore = {
    subscriptionId?: string
    accountId: string
    scope: string
    storeId: string | null
    source: string
    partnerId: string | null
    chargebeeSubscriptionId: string | null
    status: string
    primaryFlag: boolean
    startAt: string | null
    currentPeriodStart: string | null
    currentPeriodEnd: string | null
    renewalAt: string | null
    trialEndAt: string | null
    cancelAt: string | null
    canceledAt: string | null
}

export type SubscriptionItemInput = {
    planId: string
    quantity: number
    isBasePlan: boolean
    metered: boolean
}

export type UpdateSubscriptionInput = {
    id: string
    subscription: SubscriptionCore
    items: SubscriptionItemInput[]
}

export const editSubscription = (data: UpdateSubscriptionInput): Promise<any> => {
    const { id, ...payload } = data
    return api.put(`/subscriptions/${id}`, payload)
}

type UseEditSubscriptionOptions = {
    mutationConfig?: MutationConfig<typeof editSubscription>
}

export const useEditSubscription = ({ mutationConfig }: UseEditSubscriptionOptions = {}) => {
    const queryClient = useQueryClient()
    const { onSuccess, ...restConfig } = mutationConfig || {}

    return useMutation({
        mutationFn: editSubscription,
        onSuccess: (...args) => {
            queryClient.invalidateQueries({ queryKey: ['subscriptions'], refetchType: 'active' })
            onSuccess?.(...args)
        },
        ...restConfig,
    })
}
